
import React, { Component } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { toast } from 'react-toastify'
import AlertSuccess from './alertSuccess'

class ShareProfile extends Component {

  getProfileUrl = () => {
    const baseUrl = process.env.REACT_APP_BASEURL.endsWith('/')
      ? process.env.REACT_APP_BASEURL
      : `${process.env.REACT_APP_BASEURL}/`

    return `${baseUrl}dr/${this.props.username}`
  }
  closeShareModal = e => {
    if (e) e.preventDefault()

    if (this.props.showShareModal) {
      this.props.toggleShareModal()
    }
  }
  copyProfileLink = () => {
    toast(
      <AlertSuccess message={'Link Copied to Clipboard'} />
    )
  }

  shareOnWhatsApp = () => {
    const message = `Hey ! Taking your *1st step towards better mental health* was never easier and more seamless with quality support team to clarify any queries. Visit the ${this.props.name}'s profile and know all details through the link here: ${this.getProfileUrl()}`

    window.open(
      `https://wa.me/?text=${encodeURIComponent(message)}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  shareOnLinkedIn = () => {
    const url = encodeURIComponent(this.getProfileUrl())

    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  shareOnX = () => {
    const url = encodeURIComponent(this.getProfileUrl())
    const text = encodeURIComponent(
      `Check out ${this.props.name}'s profile on YesMindy`
    )

    window.open(
      `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  shareOnFacebook = () => {
    const url = encodeURIComponent(this.getProfileUrl())

    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      '_blank',
      'noopener,noreferrer'
    )
  }

  render() {
    const { name } = this.props
    const profileUrl = this.getProfileUrl()

    return (
      <>
        {this.props.showShareModal && (
          <div
            className='share-overlay'
            onClick={this.props.toggleShareModal}
          >
            <div
              className='share-modal'
              role='dialog'
              aria-modal='true'
              aria-label={`Share ${name}'s profile`}
              onClick={e => e.stopPropagation()}
            >
              <div className='share-modal-header'>
                <h5>Share Dr. {name}</h5>

                <a
                  href='#!'
                  onClick={this.closeShareModal}
                  className='share-close'
                  aria-label='Close share dialog'
                >
                  <i className='fa-solid fa-xmark'></i>
                </a>
              </div>

               <a
                href='#!'
                className='share-option'
                onClick={e => {
                  e.preventDefault()
                  this.shareOnWhatsApp()
                }}
              >
                <span className='share-icon whatsapp'>
                  <i className='fa-brands fa-whatsapp'></i>
                </span>

                <span>Share on WhatsApp</span>
              </a>

              <a
                href='#!'
                className='share-option'
                onClick={e => {
                  e.preventDefault()
                  this.shareOnLinkedIn()
                }}
              >
                <span className='share-icon linkedin'>
                  <i className='fa-brands fa-linkedin-in'></i>
                </span>

                <span>Share on LinkedIn</span>
              </a>

              <a
                href='#!'
                className='share-option'
                onClick={e => {
                  e.preventDefault()
                  this.shareOnX()
                }}
              >
                <span className='share-icon x-twitter'>
                  <i className='fa-brands fa-x-twitter'></i>
                </span>

                <span>Share on X (Twitter)</span>
              </a>

               <a
                href='#!'
                className='share-option'
                onClick={e => {
                  e.preventDefault()
                  this.shareOnFacebook()
                }}
              >
                <span className='share-icon facebook'>
                  <i className='fa-brands fa-facebook-f'></i>
                </span>

                <span>Share on Facebook</span>
              </a>

              <div className='share-url-box'>
                <div className='share-url'>
                  <i className='fa-solid fa-link' />
                  <span title={profileUrl}>
                    {profileUrl}
                  </span>
                </div>

                <CopyToClipboard
                  text={profileUrl}
                  onCopy={this.copyProfileLink}
                >
                  <button
                    type='button'
                    className='share-copy-btn'
                  >
                    Copy
                  </button>
                </CopyToClipboard>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

export default ShareProfile